import {welcome} from "./welcome";
import Breakpoint from './breakpoint';

(() => {
  welcome();
  new Breakpoint();
})();